import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b51c0b56")

_pushScopeId("data-v-b51c0b56")
const _hoisted_1 = {
  key: 0,
  class: "favorites"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("h3", null, "Seus favoritos", -1)
const _hoisted_3 = { class: "active-filters" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FavoriteCard = _resolveComponent("FavoriteCard")

  return ($props.favorites)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.favorites, (favorite) => {
            return (_openBlock(), _createBlock("div", {
              key: favorite.id,
              class: "custom-category clickable-component"
            }, [
              _createVNode(_component_FavoriteCard, { establishment: favorite }, null, 8, ["establishment"])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})